export const toCurrency = str => {
  return "$"+parseFloat(str).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}